import Axios from 'axios'
import config from '@/config/config.js'
// const baseUrl = 'http://192.168.119.122:8081/api/codetable'
const baseUrl = config.apiDomain.ALI + '/ext/core-util/public-servant/api/codetable'
const entitiesUrl = baseUrl + '/entities'
const careersPath = '/careers'
const categoriesUrl = baseUrl + '/categories?careerId='
const categoryScalesUrl = baseUrl + '/categoryScales?categoryId='
const educationLevelTypesUrl = baseUrl + '/educationLevelTypes'
const languageLevelTypesUrl = baseUrl + '/languageLevelTypes?languageTypeId='
const languageTypesUrl = baseUrl + '/languageTypes'
const officialTypesPath = '/officialTypes'
const pubHolidaysUrl = baseUrl + '/pubHolidays'
const subunitsUrl = baseUrl + '/subunits?relationTypeCode=O&entityId='
const vinculumTypesUrl = baseUrl + '/vinculumTypes'
const relativeTypesUrl = baseUrl + '/relativeTypes?getHistory=false'

Axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
// Axios.defaults.headers.get['Access-Control-Allow-Origin'] = '*'
// Axios.defaults.headers.get['Access-Control-Allow-Headers'] = 'Authorization,Origin, X-Requested-With, Content-Type, Accept'
// Axios.defaults.headers.get['Access-Control-Allow-Methods'] = 'GET,POST'
Axios.defaults.headers.timeout = 8000

export default {

  getCareersByEntityId (cb, entityId) {
    Axios.get(entitiesUrl + entityId + careersPath).then(
      response => {
        cb(response.data)
      },
      error => {
        console.error(error)
      }
    )
  },

  getCareers (cb) {
    Axios.get(baseUrl + careersPath).then(
      response => {
        cb(response.data)
      },
      error => {
        console.error(error)
      }
    )
  },

  getCategories (cb, careerId) {
    Axios.get(categoriesUrl + careerId).then(
      response => {
        cb(response.data)
      },
      error => {
        console.error(error)
      }
    )
  },

  getCategoryScales (cb, categoryId) {
    Axios.get(categoryScalesUrl + categoryId).then(
      response => {
        cb(response.data)
      },
      error => {
        console.error(error)
      }
    )
  },

  getEducationLevelTypes (cb) {
    Axios.get(educationLevelTypesUrl).then(
      response => {
        cb(response.data)
      },
      error => {
        console.error(error)
      }
    )
  },

  getLanguageLevelTypes (cb, typeId) {
    Axios.get(languageLevelTypesUrl + typeId).then(
      response => {
        cb(response.data)
      },
      error => {
        console.error(error)
      }
    )
  },

  getLanguageTypes (cb) {
    Axios.get(languageTypesUrl).then(
      response => {
        cb(response.data)
      },
      error => {
        console.error(error)
      }
    )
  },

  getOfficialTypesByEntityId (cb, entityId) {
    Axios.get(entitiesUrl + '/' + entityId + officialTypesPath).then(
      response => {
        cb(response.data)
      },
      error => {
        console.error(error)
      }
    )
  },

  getOfficialTypes (cb) {
    Axios.get(baseUrl + officialTypesPath).then(
      response => {
        cb(response.data)
      },
      error => {
        console.error(error)
      }
    )
  },

  getPubHolidays (cb) {
    Axios.get(pubHolidaysUrl).then(
      response => {
        cb(response.data)
      },
      error => {
        console.error(error)
      }
    )
  },

  getSubunits (cb, entityId) {
    Axios.get(subunitsUrl + entityId).then(
      response => {
        cb(response.data)
      },
      error => {
        console.error(error)
      }
    )
  },

  getAllSubunits (cb, entityId) {
    Axios.get(baseUrl + '/subunits?relationTypeCode=A&entityId=' + entityId).then(
      response => {
        cb(response.data)
      },
      error => {
        console.error(error)
      }
    )
  },

  getVinculumTypes (cb) {
    Axios.get(vinculumTypesUrl).then(
      response => {
        cb(response.data)
      },
      error => {
        console.error(error)
      }
    )
  },

  getRelativeTypes (cb) {
    Axios.get(relativeTypesUrl).then(
      response => {
        cb(response.data)
      },
      error => {
        console.error(error)
      }
    )
  },

  getPubHolidaysByStartEndDay (cb, startDate, endDate) {
    return new Promise((resolve, reject) => {
      Axios.get(pubHolidaysUrl + '/' + startDate + '/' + endDate).then(
        response => {
          cb(response.data)
          resolve()
        },
        error => {
          console.error(error)
        }
      )
    })
  }

}
